import { api } from 'API';
import { addImposterToUrl } from 'Utils';
const baseUrl = '/LongTermEquipment';

export interface ILongtermEquipmentCard {
  validFromDate: string;
  validToDate: string;
  nextEntitleDate: string;
  description: string;
  lastRefStartDate?: string;
  medicalReferralId?: number;
  additionalInfoLink?: string;
  filterLabel: string;
  isAvailable: boolean;
  isPermanent: boolean;
  shikumSubTypeId?: number;
}

export const getCards = async () => {
  const res = await api.get<ILongtermEquipmentCard[]>(
    addImposterToUrl(baseUrl, true)
  );
  if (res) return res?.data;
};
